export const filterByThresholdGood =  (data,threshold) => {


  return data.filter(item => {
     // Iterate over each property of the item
     return Object.values(item.pollutants).every(prop => {
       // prop is now the nested object, so we check its properties

        return prop.pi <= threshold;
     });
   });
}

export const filterByThresholdModerate =  (data,threshold) => {


  return data.filter(item => {
     // Iterate over each property of the item
     return Object.values(item.pollutants).every(prop => {
       // prop is now the nested object, so we check its properties

        return (prop.pi < 50);
     });
   });
}


export const filterByThresholdUnhealthy =  (data,threshold) => {


  return data.filter(item => {
     // Iterate over each property of the item
     return Object.values(item.pollutants).some(prop => {
       // prop is now the nested object, so we check its properties

        return prop.pi > 50;
     });
   });
}
